import { message } from "antd";
import apiHelper from "./apiHelper";

export const createNewPayment = async (body: any) => {
  const url = "/payments";
  const response: any = await apiHelper.post(url, body);

  if (response.status !== 201) {
    message.error(response.data.message);
    return null;
  }

  if (!response.data.url) {
    message.info("You have 100% discount. No payment required. Credits added to your account.");
    return response;
  }

  window.location.href = response.data.url;
  return response;
};

export const getUserCredits = async () => {
  const url = "/credits/detail";
  const response = await apiHelper.get(url, {});
  if (response.data.statusCode === 200) {
    return response.data.data;
  }

  message.error(response.data.message);

  return null;
};
